import { DataTableColumn } from "../../../../components/common/datatable/DataTableTypes";
import { createClickableLink } from "../../../../components/common/datatable/DataTableUtils";
import { SearchInputWrapper } from "../../../../components/common/datatable/filter/SearchInputWrapper";
import { SearchDatePickerWrapper } from "../../../../components/common/datatable/filter/SearchDatePickerWrapper";
import { formatValueAsDateAndTime } from "../../../../helpers/utils/DateUtils";
import Breadcrumb from "../../../../components/common/Breadcrumbs";
import { DataTable } from "../../../../components/common/datatable/DataTable";
import { useSearchErrorLogsQuery, useResolveErrorByIdMutation } from "../errorLogsApi";
import React, { FormEvent, useEffect, useState } from "react";
import ConfirmationModal from "../../../../components/layout/modal/ConfirmationModal";
import { useFindUserSettingsByGroupNameQuery } from "../../../../components/common/userSetting/userSettingsApi";
import { hasPermission } from "../../../../helpers/utils/AccessControlUtils";

const ErrorLogs = () => {

    const [showResolveVisibilityConfirmation, setShowResolveVisibilityConfirmation] = useState(false);
    const { data: userSetting } = useFindUserSettingsByGroupNameQuery("Error Logs");
    const [orderId, setOrderId] = useState(null);
    const [orderLogId, setOrderLogId] = useState(null);
    const [resolveErrorLogs, { isLoading: resolveErrorLogApiResponse }] = useResolveErrorByIdMutation();
    const [crumbs] = useState([
        { content: "Home", url: "/home" },
        { content: "Error Logs", url: "" }]
    )
    useEffect(() => {
        document.title = 'Error Logs';
    }, []);

    const handleResolveErrorLog = async (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        if (e) {
            return resolveErrorLogs({ orderId: orderId, orderLogId: orderLogId });
        }
    }
    const columns: DataTableColumn[] = [
        {
            label: "Order No.",
            accessor: "order.customerOrderNumber",
            cell: (props: any) => {
                let path = "/orders/" + props.row.original.order.id;
                return createClickableLink(path, props.row.original.order.customerOrderNumber, userSetting, false, "", ["ORDR-R"]);
            },
            filterOptions: [{
                filterComponent: <SearchInputWrapper type={"text"} placeholder={"Enter Order No"}
                    name={"customerOrderNumber"} accessor={"customerOrderNumber"} />,
                overrideFilterLabel: "Oder No.",
                overrideFilterAccessor: "customerOrderNumber"
            }]
        },
        {
            label: "Date",
            accessor: "creationDate",
            cell: (props: any) => {
                return formatValueAsDateAndTime(props.row.original.creationDate);
            },
            filterOptions: [{
                filterComponent: <SearchDatePickerWrapper accessor={"createdDateFrom"} />,
                overrideFilterLabel: "Created Date - From.",
                overrideFilterAccessor: "createdDateFrom"
            },
            {
                filterComponent: <SearchDatePickerWrapper accessor={"createdDateTo"} />,
                overrideFilterAccessor: "createdDateTo",
                overrideFilterLabel: "Created Date - To",
            }]
        },
        {
            label: "Message", accessor: "logMessage",
            cell: (props: any) => {
                return <>
                    <span title={props.row.original.detailedLogMessage}>{props.value}</span>
                </>

            },
            filterOptions: [{
                filterComponent: <SearchInputWrapper type={"text"} placeholder={"Enter Message..."}
                    name={"logMessage"} accessor={"logMessage"}
                />,
            }],
        },

        {
            label: "Action",
            accessor: "logType",
            canSort: false,
            visibility: { showByDefault: hasPermission(["ERRLOG-U"]) === false },
            cell: (props: any) => {
                return (
                    <span
                        className="text-[12px] bg-[#5F9EA0] text-text-0 px-2 py-1 font-bold rounded cursor-pointer transition-colors duration-150"
                        onClick={() => {
                            setOrderId(props.row.original.order.id);
                            setOrderLogId(props.row.original.id);
                            setShowResolveVisibilityConfirmation(true);
                        }}
                    >
                        Resolve
                    </span>
                );
            }
        }
    ]


    return (

        <div className="user-container px-4 py-2">
            <div className="flex justify-between mb-2.5">
                <Breadcrumb crumbs={crumbs} />
            </div>
            <DataTable
                columns={columns}
                actions={{
                    fetchAction: useSearchErrorLogsQuery,
                    exportAction: null
                }}
                userSettingGroup={"Error Logs"}
                defaultSortOptions={{
                    accessor: "creationDate",
                    direction: "desc"
                }}
            />
            {showResolveVisibilityConfirmation &&
                <ConfirmationModal
                    show={showResolveVisibilityConfirmation}
                    setShow={setShowResolveVisibilityConfirmation}
                    title={"Resolve Error"} bodyMessage={"Are you sure you want to resolve this error?"}
                    onSubmit={handleResolveErrorLog}
                    isLoading={resolveErrorLogApiResponse}
                />
            }
        </div>
    );
};
export default ErrorLogs;
